import api from '@/mixins/api'
import toast from '@/mixins/toast'

export default {
	data() {
		return {
			updatingBlock: null
		}
	},
	methods: {
		async updateBlock(ip, blocked) {
			this.updatingBlock = ip
			const action = blocked ? 'block' : 'unblock'

			try {
				const res = await this.post(`/block/${ip}`, {
					body: JSON.stringify({ blocked })
				})
				if (!res.ok) {
					this.toastErr(`Failed to ${action} IP address *${ip}*`)
				} else {
					this.toast(`Successfully *${action}ed* IP address *${ip}*`)
					this.refresh()
				}
			} catch (err) {
				this.toastErr(`Failed to ${action} IP address *${ip}*`)
			} finally {
				this.updatingBlock = null
			}
		},
		doBlock({ ip }) {
			if (!this.updatingBlock) this.updateBlock(ip, true)
		},
		doUnblock({ ip }) {
			if (!this.updatingBlock) this.updateBlock(ip, false)
		}
	},
	mixins: [api, toast]
}
